import gql from 'graphql-tag';

export const createTestDriveBooking = gql`
  mutation createTestDriveBooking(
    $testDriveBookingAppointmentAttempt: TestDriveBookingAppointmentAttemptInput!
  ) {
    createTestDriveBooking(
      testDriveBookingAppointmentAttempt: $testDriveBookingAppointmentAttempt
    ) {
      status
    }
  }
`;

export const changeTestDriveBooking = gql`
  mutation createTestDriveBookingReschedule(
    $testDriveBookingReschedule: TestDriveBookingRescheduleInput!
  ) {
    createTestDriveBookingReschedule(
      testDriveBookingReschedule: $testDriveBookingReschedule
    ) {
      status
    }
  }
`;

export const cancelTestDriveBooking = gql`
  mutation cancelTestDriveBooking(
    $bookingAppointmentCancellation: BookingAppointmentCancellationInput!
  ) {
    cancelTestDriveBooking(
      bookingAppointmentCancellation: $bookingAppointmentCancellation
    ) {
      id
    }
  }
`;

export const createRequest = gql`
  mutation createRequest(
    $testDriveRequestAttempt: TestDriveRequestAttemptInput!
  ) {
    createRequest(testDriveRequestAttempt: $testDriveRequestAttempt) {
      status
    }
  }
`;
